<template>
  <div class="no-results container-fluid">
    <div class="row">
      <div class="col">
        <div class="message">
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NoResults',
  computed: {
    ...mapState({
      errorDefaultMessage: state => state.error.defaultMessage,
      unavailableDefaultMessage: state => state.unavailableDefaultMessage
    }),
    message() {
      return this.errorDefaultMessage ?? this.unavailableDefaultMessage;
    }
  }
}
</script>

<style lang="scss">
#core-availability {
  .no-results {
    padding: 1rem 0 0;

    .message {
      background-color: $danger;
      color: $white;
      padding: 0.2rem 0.5rem;
      font-weight: bold;
    }
  }
}
</style>
